import { MD5 } from 'crypto-js'

let createHash = function () {
  return MD5((new Date()).toString() + Math.random()).toString()
}

export {
  createHash
}
